import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { GET_PRICING_NUMBERS_SUCCESS, GetPricingNumbersAction } from './pricing-numbers.action';
import { IState } from '../../shared/models/state';

@Injectable()
export class PricingNumbersResolve implements Resolve<any> {
  constructor(private store: Store<IState>, private action$: Actions) {}

  resolve(route: ActivatedRouteSnapshot) {
    this.store.dispatch(new GetPricingNumbersAction(route.params.code));
    return this.action$.ofType(GET_PRICING_NUMBERS_SUCCESS).take(1);
  }
}
